import React, { useState } from 'react';
import { Brain, Plus, List, Users, CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ActionCard from '../CallAgent/ActionCard';
import FullScreenModal from '../shared/FullScreenModal';
import PlaceRequestPage from './PlaceRequestPage';

interface LeadGenActionPanelProps {
  onHowIWork: () => void;
}

const LeadGenActionPanel: React.FC<LeadGenActionPanelProps> = ({ onHowIWork }) => {
  const navigate = useNavigate();
  const [showRequestLeadsModal, setShowRequestLeadsModal] = useState(false);

  const handlePreQualifiedLeads = () => {
    navigate('/pre-qualified-leads');
  };

  const handleLeadRequests = () => {
    navigate('/lead-requests');
  };

  const handleQualifiedLeads = () => {
    navigate('/leads/outbound');
  };

  return (
    <>
      <div className="pt-14 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          <ActionCard
            icon={Brain}
            title="How I Work"
            description="Learn how I research, qualify and enrich leads."
            onClick={onHowIWork}
          />
          <ActionCard
            icon={Plus}
            title="Request Leads"
            description="Specify your target criteria and I will generate matching leads."
            onClick={() => setShowRequestLeadsModal(true)}
          />
          <ActionCard
            icon={List}
            title="Lead Requests"
            description="Track all your lead requests and their status."
            onClick={handleLeadRequests}
          />
          <ActionCard
            icon={Users}
            title="Pre-Qualified Leads"
            description="Where lead research and qualification happens."
            onClick={handlePreQualifiedLeads}
          />
          <ActionCard
            icon={CheckCircle}
            title="Qualified Leads"
            description="Qualified and enriched leads ready for outreach."
            onClick={handleQualifiedLeads}
          />
        </div>
      </div>

      <FullScreenModal
        isOpen={showRequestLeadsModal}
        onClose={() => setShowRequestLeadsModal(false)}
        title="Place Lead Request"
        description="AI Agent will generate qualified leads based on your criteria"
        branded={true}
      >
        <PlaceRequestPage />
      </FullScreenModal>
    </>
  );
};

export default LeadGenActionPanel;
